/**
 * plugins/vuetify.ts
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Composables
import { createVuetify } from 'vuetify'

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  theme: {
    themes: {
      light: {
        colors: {
          // Brand colors from client design
          primary: '#821305',      // Deep red - primary brand color
          secondary: '#cabaa4',    // Light tan/beige - secondary accent
          background: '#FFEFD6',   // Cream - page background
          red: '#821204',          // Red variant
          brown: '#cabaa4',        // Brown/tan variant
          black: '#0f0f0e',        // Near-black text color
          'white-accent': '#FFEFD6',
          'white-accent-darken-3': '#201300',
          'white-accent-darken-4': '#221500'
        }
      }
    }
  }
})
